import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { KeepTogether, Section, SectionNumberingProvider, SigningBlock, TemplateDocument, TemplateFooter, TemplateLetterhead, } from '../../../atoms/index.js';
import { BEKRAFTELSE_TEXT, PersonuppgiftSharedBody, SHARED_SAMPLE_VALUES, SHARED_SECTION_DEFS, buildSharedFields, } from '../../personuppgiftsbilaga/shared.js';
export const metadata = {
    sections: [
        ...SHARED_SECTION_DEFS,
        { ref: 'bekraftelse', title: 'Bekräftelse' },
    ],
    templateKey: 'personuppgiftsavtal',
    version: 'v1',
    category: 'Övriga avtal',
    title: 'Personuppgiftsavtal · Version 2026',
    shortTitle: 'Personuppgiftsavtal',
    formNumber: 'Formulär R-17',
    preamble: 'Information om hyresvärdens behandling av hyresgästens personuppgifter.',
    description: 'GDPR-information (artikel 13) om hur hyresvärden behandlar hyresgästens ' +
        'personuppgifter — som fristående, signerat dokument.\n\n' +
        'Vem undertecknar: hyresvärden och hyresgästen. Leverans: skickas via ' +
        'Scrive.\n\n' +
        'Ska informationen i stället bifogas ett hyresavtal och signeras ' +
        'tillsammans med det — använd bilagan "Personuppgiftsbilaga" från ' +
        'avtalets Bilagor-flik i stället.',
    status: 'active',
    signingMode: 'scrive',
    signingPlacementAnchors: 'per-party-label',
    partySlots: [
        {
            id: 'lessor',
            label: 'Hyresvärd',
            role: 'lessor',
            ordinal: 0,
            required: true,
            signs: true,
        },
        {
            id: 'lessee',
            label: 'Hyresgäst',
            role: 'lessee',
            ordinal: 0,
            required: true,
            signs: true,
        },
    ],
};
export const variableSchema = buildSharedFields('standalone');
export const sampleValues = SHARED_SAMPLE_VALUES;
export function Letterhead() {
    return (_jsx(TemplateLetterhead, { title: metadata.title, formNumber: metadata.formNumber }));
}
export function PageFooter() {
    return _jsx(TemplateFooter, { formNumber: metadata.formNumber });
}
export function Body(props) {
    const { values, mode, signatories } = props;
    return (_jsxs(SectionNumberingProvider, { sections: metadata.sections ?? [], values: values, mode: mode, children: [_jsx("p", { className: "mb-4 italic text-stone-600", children: metadata.preamble }), _jsx(PersonuppgiftSharedBody, { ...props }), _jsx(KeepTogether, { children: _jsxs(Section, { sectionRef: "bekraftelse", title: "Bekr\u00E4ftelse", children: [_jsx("p", { className: "mb-6 text-[10.5px] leading-relaxed text-stone-700", children: BEKRAFTELSE_TEXT }), _jsx(SigningBlock, { statement: true, parties: [
                                { label: 'Hyresvärd', role: 'lessor', ordinal: 0 },
                                { label: 'Hyresgäst', role: 'lessee', ordinal: 0 },
                            ], signatories: signatories })] }) })] }));
}
export function Component(props) {
    return (_jsx(TemplateDocument, { header: _jsx(Letterhead, {}), footer: _jsx(PageFooter, {}), children: _jsx(Body, { ...props }) }));
}
//# sourceMappingURL=index.js.map